class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    document.querySelectorAll('[id*="cart-icon-bubble"]').forEach((cartLink) => {
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    })
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add('active');
      this.classList.add('animate');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    if(document.querySelectorAll('.popup-modal.active').length == 0){
      document.body.style.paddingRight = this.getScrollbarWidth() + 'px';
      document.body.classList.add('overflow-hidden');
    }
  }

  close() {
    this.classList.remove('animate');
    setTimeout(() => {
      this.classList.remove('active');
      if(document.querySelectorAll('.popup-modal.active').length == 0){
        document.body.classList.remove('overflow-hidden');
        document.body.style.paddingRight = '';
      }
    }, 500);
    removeTrapFocus(this.activeElement);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if(sectionElement) sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      if(section.id == 'cart-free-delivery' && document.querySelector('#product-page-free-delivery')){
        document.querySelector('#product-page-free-delivery').innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
      if(section.id == 'cart-icon-bubble' && document.querySelector('.footer-sticky-nav__item__icon .cart-count-bubble')){
        const parser = new DOMParser();
        const bubble = parser.parseFromString(this.getSectionInnerHTML(parsedState.sections[section.id], section.selector), 'text/html');
        var ib = bubble.querySelector('.cart-count-bubble')?bubble.querySelector('.cart-count-bubble').innerHTML : '' ;
        document.querySelector('.footer-sticky-nav__item__icon .cart-count-bubble').innerHTML = ib;
      }
    });

    setTimeout(() => {
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
      {
        id: 'cart-icon-bubble--mobile'
      },
      {
        id: 'cart-free-delivery'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
  getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-icon-bubble--mobile',
        section: 'cart-icon-bubble--mobile',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
// CEP lookup supplies the destination; shipping prices come only from Shopify.
class WokeeCepShipping extends HTMLElement {
  static savedCep = '';
  static addressCache = new Map();
  static queue = Promise.resolve();
  static storageKey = 'wokee-shipping-cep-v1';
  static states = {
    AC: 'Acre', AL: 'Alagoas', AP: 'Amapá', AM: 'Amazonas', BA: 'Bahia', CE: 'Ceará',
    DF: 'Distrito Federal', ES: 'Espírito Santo', GO: 'Goiás', MA: 'Maranhão',
    MT: 'Mato Grosso', MS: 'Mato Grosso do Sul', MG: 'Minas Gerais', PA: 'Pará',
    PB: 'Paraíba', PR: 'Paraná', PE: 'Pernambuco', PI: 'Piauí', RJ: 'Rio de Janeiro',
    RN: 'Rio Grande do Norte', RS: 'Rio Grande do Sul', RO: 'Rondônia', RR: 'Roraima',
    SC: 'Santa Catarina', SP: 'São Paulo', SE: 'Sergipe', TO: 'Tocantins'
  };

  connectedCallback() {
    this.input = this.querySelector('input');
    this.button = this.querySelector('button');
    this.message = this.querySelector('[data-shipping-message]');
    this.destination = this.querySelector('[data-shipping-destination]');
    this.list = this.querySelector('[data-shipping-rates]');
    if (!this.input || !this.button || !this.message || !this.destination || !this.list) return;
    this.generation = 0;
    this.onInput = () => {
      this.generation++;
      clearTimeout(this.refreshTimer);
      this.input.value = this.formatCep(this.input.value);
      this.input.removeAttribute('aria-invalid');
      this.clearResults();
      this.setBusy(false);
      this.message.textContent = 'Informe o CEP de entrega e clique em Calcular.';
      WokeeCepShipping.savedCep = '';
      try { window.sessionStorage.removeItem(WokeeCepShipping.storageKey); } catch (_) {}
    };
    this.onClick = () => this.calculate();
    this.onKeydown = (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        event.stopPropagation();
        this.calculate();
      }
    };
    this.input.addEventListener('input', this.onInput);
    this.input.addEventListener('keydown', this.onKeydown);
    this.button.addEventListener('click', this.onClick);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        if (this.input.value.replace(/\D/g, '').length !== 8) return;
        this.generation++;
        this.clearResults();
        this.setBusy(true);
        this.message.textContent = 'Atualizando o frete…';
        clearTimeout(this.refreshTimer);
        this.refreshTimer = setTimeout(() => this.calculate(), 250);
      });
    }
    let cep = WokeeCepShipping.savedCep;
    try { cep = cep || window.sessionStorage.getItem(WokeeCepShipping.storageKey) || ''; } catch (_) {}
    if (/^\d{8}$/.test(cep)) {
      this.input.value = this.formatCep(cep);
      this.refreshTimer = setTimeout(() => this.calculate(), 250);
    }
  }

  disconnectedCallback() {
    this.generation++;
    clearTimeout(this.refreshTimer);
    if (this.unsubscribe) this.unsubscribe();
    if (this.input) {
      this.input.removeEventListener('input', this.onInput);
      this.input.removeEventListener('keydown', this.onKeydown);
    }
    if (this.button) this.button.removeEventListener('click', this.onClick);
  }

  formatCep(value) {
    return value.replace(/\D/g, '').slice(0, 8).replace(/^(\d{5})(\d)/, '$1-$2');
  }

  clearResults() {
    this.list.replaceChildren();
    this.destination.textContent = '';
    this.destination.hidden = true;
  }

  setBusy(busy) {
    this.button.disabled = busy;
    this.button.textContent = busy ? 'Calculando…' : 'Calcular';
    this.setAttribute('aria-busy', String(busy));
  }

  async requestJson(url, options = {}) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);
    try {
      const response = await fetch(url, { ...options, signal: controller.signal });
      if (!response.ok) throw new Error('request');
      return await response.json();
    } finally {
      clearTimeout(timeout);
    }
  }

  calculate() {
    clearTimeout(this.refreshTimer);
    const generation = ++this.generation;
    const cep = this.input.value.replace(/\D/g, '');
    this.clearResults();
    if (!/^\d{8}$/.test(cep)) {
      this.setBusy(false);
      this.input.setAttribute('aria-invalid', 'true');
      this.message.textContent = 'Digite um CEP válido com 8 números.';
      this.input.focus();
      return Promise.resolve();
    }
    this.input.removeAttribute('aria-invalid');
    this.setBusy(true);
    this.message.textContent = 'Consultando o CEP e as opções de frete…';
    const current = () => this.isConnected && this.generation === generation;
    // Shopify prepares rates for the session cart; serialize this component's requests.
    const run = async () => {
      if (!current()) return;
      try {
        let address = WokeeCepShipping.addressCache.get(cep);
        if (!address) {
          try {
            address = await this.requestJson(`https://viacep.com.br/ws/${cep}/json/`, {
              credentials: 'omit', referrerPolicy: 'no-referrer'
            });
          } catch (_) { throw new Error('lookup'); }
          if (!current()) return;
          if (address.erro || !WokeeCepShipping.states[address.uf]) throw new Error('cep');
          WokeeCepShipping.addressCache.set(cep, address);
        }
        if (!current()) return;
        WokeeCepShipping.savedCep = cep;
        try { window.sessionStorage.setItem(WokeeCepShipping.storageKey, cep); } catch (_) {}
        this.destination.hidden = false;
        this.destination.textContent = [address.localidade, address.uf].filter(Boolean).join(' – ');
        const params = new URLSearchParams({
          'shipping_address[zip]': cep,
          'shipping_address[country]': 'Brazil',
          'shipping_address[province]': WokeeCepShipping.states[address.uf],
          'shipping_address[city]': address.localidade || ''
        });
        const root = window.Shopify?.routes?.root || '/';
        const base = `${root.endsWith('/') ? root : root + '/'}cart/`;
        const settings = { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } };
        await this.requestJson(`${base}prepare_shipping_rates.json?${params}`, { ...settings, method: 'POST' });
        let data = null;
        for (let attempt = 0; attempt < 10; attempt++) {
          if (!current()) return;
          data = await this.requestJson(`${base}async_shipping_rates.json?${params}`, settings);
          if (!current()) return;
          if (data !== null) break;
          if (attempt < 9) await new Promise(resolve => setTimeout(resolve, 800));
        }
        if (!current()) return;
        if (!data || !Array.isArray(data.shipping_rates)) throw new Error('rates');
        this.renderRates(data.shipping_rates);
      } catch (error) {
        if (!current()) return;
        this.list.replaceChildren();
        if (error.message === 'cep') {
          this.input.setAttribute('aria-invalid', 'true');
          this.message.textContent = 'CEP não encontrado. Confira os números e tente novamente.';
        } else if (error.message === 'lookup') {
          this.message.textContent = 'Não foi possível consultar o CEP. Tente novamente ou consulte o frete no checkout.';
        } else {
          this.message.textContent = 'Não foi possível calcular o frete agora. Tente novamente ou consulte no checkout.';
        }
      } finally {
        if (current()) this.setBusy(false);
      }
    };
    const task = WokeeCepShipping.queue.then(run, run);
    WokeeCepShipping.queue = task.catch(() => {});
    return task;
  }

  renderRates(rates) {
    this.list.replaceChildren();
    if (!rates.length) {
      this.message.textContent = 'Nenhuma opção de frete disponível para este CEP. Confira o endereço no checkout.';
      return;
    }
    const fragment = document.createDocumentFragment();
    for (const rate of rates) {
      if (rate.price === null || rate.price === '' || rate.price === undefined) throw new Error('rates');
      const amount = Number(rate.price);
      if (!Number.isFinite(amount) || amount < 0) throw new Error('rates');
      const row = document.createElement('li');
      row.className = 'wokee-cep-shipping__rate';
      const name = document.createElement('span');
      name.textContent = rate.presentment_name || rate.name || 'Frete';
      const price = document.createElement('strong');
      price.textContent = amount === 0 ? 'Grátis' : new Intl.NumberFormat('pt-BR', {
        style: 'currency', currency: rate.currency || this.dataset.currency || 'BRL'
      }).format(amount);
      row.append(name, price);
      fragment.append(row);
    }
    this.list.append(fragment);
    this.message.textContent = 'Opções de frete para o seu carrinho:';
  }
}

if (!customElements.get('wokee-cep-shipping')) {
  customElements.define('wokee-cep-shipping', WokeeCepShipping);
}
